import { render, staticRenderFns } from "./casetas.vue?vue&type=template&id=9fe4a2f2&scoped=true"
import script from "./casetas.vue?vue&type=script&lang=js"
export * from "./casetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe4a2f2",
  null
  
)

export default component.exports